/* Thryfty Cart v3 — Hardened + Polished. Moved out of snippets/cart-drawer.liquid (see cart-drawer-tc.css note). Liquid values arrive via window.__tcDrawer, set inline by the snippet. */
/* ═══ Thryfty Cart v3 — Hardened + Polished ═══ */

/* ── Toast system (created dynamically to survive section re-renders) ── */
var _tcToastTimer = null;
function _tcEnsureToast() {
  var el = document.getElementById('TcToast');
  if (el) return el;
  el = document.createElement('div');
  el.id = 'TcToast';
  el.className = 'tc-toast';
  el.innerHTML = '<span id="TcToastMsg"></span><button type="button" class="tc-toast__action" id="TcToastAction" style="display:none"></button>';
  document.body.appendChild(el);
  return el;
}
function tcToast(msg, actionLabel, actionFn, duration) {
  var el = _tcEnsureToast();
  var msgEl = document.getElementById('TcToastMsg');
  var actEl = document.getElementById('TcToastAction');
  if (!el || !msgEl) return;
  clearTimeout(_tcToastTimer);
  msgEl.textContent = msg;
  if (actionLabel && actionFn) {
    actEl.textContent = actionLabel;
    actEl.style.display = '';
    actEl.onclick = function() {
      actionFn();
      tcToastHide();
    };
  } else {
    actEl.style.display = 'none';
    actEl.onclick = null;
  }
  el.classList.add('is-visible');
  _tcToastTimer = setTimeout(function() { tcToastHide(); }, duration || 4000);
}
function tcToastHide() {
  var el = document.getElementById('TcToast');
  if (el) el.classList.remove('is-visible');
  clearTimeout(_tcToastTimer);
}

/* ── Block Redo's SDK from auto-adding coverage to the browsing cart ──────────────
   Coverage is opt-in at checkout via our .tc-cov mirror. Redo's app embed ships with
   packageProtectionAutoCheck ON, so its SDK auto-adds the $3.98 coverage variant on
   cart changes; left unchecked it piled up multiple coverage lines that our old wrapper
   then refused to let anything remove. We now no-op any /cart/add that includes the Redo
   variant UNLESS our own Checkout+ flow set __tcCovCheckout. tcCovSweep() clears any
   coverage already stuck in the cart on load. */
(function() {
  var REDO_VID = String(window.__tcDrawer.redoVariantId);
  var _origFetch = window.fetch;
  window.fetch = function(url, opts) {
    try {
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      if (u.indexOf('/cart/add') !== -1 && opts && opts.body && !window.__tcCovCheckout) {
        var body = typeof opts.body === 'string' ? JSON.parse(opts.body) : opts.body;
        var items = (body && body.items) ? body.items : ((body && body.id != null) ? [body] : []);
        var addsRedo = items.some(function(it) { return String(it.id) === REDO_VID; });
        if (addsRedo) {
          /* Silently no-op Redo's auto-add — return an empty success */
          return Promise.resolve(new Response('{"items":[]}', { status: 200, headers: { 'Content-Type': 'application/json' } }));
        }
      }
      /* Checkout+ in flight: we have just added coverage and are navigating to /checkout.
         Redo's SDK also manages this variant and can yank it mid-navigation, which mutates
         the cart while Shopify is building the checkout session. Block those removals until
         we land on checkout; the pageshow handler below clears the flag on the way back. */
      if (window.__tcCovCheckout && u.indexOf('/cart/change') !== -1 && opts && opts.body) {
        var cbody = typeof opts.body === 'string' ? JSON.parse(opts.body) : opts.body;
        if (cbody && Number(cbody.quantity) === 0 && String(cbody.id || '').indexOf(REDO_VID) === 0) {
          return Promise.resolve(new Response('{}', { status: 200, headers: { 'Content-Type': 'application/json' } }));
        }
      }
    } catch(e) {}
    return _origFetch.apply(this, arguments);
  };
})();

/* ── Patch renderContents ──────────────────────────────────────── */
(function() {
  function patchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__tcPatched) return;
    drawer.__tcPatched = true;
    var origRender = drawer.renderContents.bind(drawer);
    drawer.renderContents = function(parsedState) {
      origRender(parsedState);
      var hasItems = drawer.querySelector('.tc-item');
      if (hasItems) { drawer.classList.remove('is-empty'); }
      else { drawer.classList.add('is-empty'); }
      restoreCartIcon(parsedState);
      /* Re-init the reservation countdown after re-render (reads the persisted start) */
      tcReserveInit();
      /* Safety net: strip any coverage Redo's SDK slipped into the browsing cart on this change */
      tcCovSweep();
      /* Refill the tier ladder (renderContents reset the fills to 0) */
      tcUpdateTierBar();
      /* Ring attach row: pick an in-stock default after each render */
      if (window.tcAttachInitAll) window.tcAttachInitAll();
      /* Vault pendant whose necklace just left the cart: take it out too */
      if (window.tcVaultSweep) window.tcVaultSweep();
    };
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { patchDrawer(); tcAutoAddRedo(); tcUpdateTierBar(); tcCovSweep(); tcReserveInit(); });
  } else {
    setTimeout(function() { patchDrawer(); tcAutoAddRedo(); tcUpdateTierBar(); tcCovSweep(); tcReserveInit(); }, 0);
  }
  /* Returning from checkout (back button, incl. bfcache restore where no DOMContentLoaded
     fires and the old JS context is reused): clear the in-flight checkout flags, otherwise
     __tcCovCheckout stays true forever — which disables BOTH the Redo auto-add block and
     tcCovSweep, letting $3.98 coverage lines pile up in the cart. Then sweep any leftover. */
  window.addEventListener('pageshow', function() {
    window.__tcCovCheckout = false;
    window.__tcRedoToggleRemove = false;
    tcCovSweep();
  });
})();

/* ── Restore custom cart icon ──────────────────────────────────── */
function restoreCartIcon(parsedState) {
  var bubble = document.getElementById('cart-icon-bubble');
  var count = 0;
  if (parsedState && parsedState.sections && parsedState.sections['cart-icon-bubble']) {
    var tmp = new DOMParser().parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');
    var countEl = tmp.querySelector('.cart-count-bubble span[aria-hidden]');
    if (countEl) count = parseInt(countEl.textContent, 10) || 0;
  }
  /* The mobile header (snippets/pdp-top-bar.liquid) prints its own count once at load; keep it in step with every drawer render. */
  document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  if (!bubble) return;
  bubble.innerHTML =
    '<div class="cart-icon-placeholder"><span class="visually-hidden">Cart</span></div>' +
    '<span class="visually-hidden">Cart</span>' +
    '<div class="cart-count-bubble">' +
      (count > 0 && count < 100 ? '<span aria-hidden="true">' + count + '</span>' : '') +
      '<span class="visually-hidden">' + count + ' item' + (count !== 1 ? 's' : '') + '</span>' +
    '</div>';
}

/* ── Quantity with error handling ──────────────────────────────── */
function tcQty(btn, delta) {
  var wrap = btn.closest('.tc-qty');
  var input = wrap.querySelector('.tc-qty__val');
  var oldQty = parseInt(input.value, 10);
  var newQty = Math.max(0, oldQty + delta);
  var key = wrap.dataset.key;
  var index = parseInt(wrap.dataset.index, 10);
  var item = btn.closest('.tc-item');

  /* Enforce quantity rules from Dawn's hidden form if available */
  var dawnInput = document.querySelector('input[data-quantity-variant-id][data-index="' + wrap.dataset.index + '"]');
  if (dawnInput) {
    var min = parseInt(dawnInput.getAttribute('min'), 10) || 0;
    var max = parseInt(dawnInput.getAttribute('max'), 10) || Infinity;
    var step = parseInt(dawnInput.getAttribute('step'), 10) || 1;
    if (newQty > 0 && newQty < min) newQty = min;
    if (newQty > max) {
      tcToast('Max ' + max + ' per order for this item');
      return;
    }
    if (step > 1 && newQty % step !== 0) {
      newQty = Math.round(newQty / step) * step;
    }
  }

  /* Immediate visual feedback */
  btn.classList.add('is-busy');
  if (item) item.classList.add('tc-item--loading');
  input.value = newQty;

  function tcQtyFail(msg) {
    input.value = oldQty;
    if (item) item.classList.remove('tc-item--loading');
    btn.classList.remove('is-busy');
    tcToast(msg || 'Couldn’t update quantity — try again');
  }

  /* Resolve the CURRENT line item at click time. data-key holds a line-item key
     (variant:properties-hash); Shopify REGENERATES that hash whenever an
     automatic discount reallocates, so a key rendered earlier can be stale and
     /cart/change.js returns "no valid id or line parameter". Re-fetch the cart
     and match by variant id to get the live key, falling back to line position. */
  var variantId = key ? key.split(':')[0] : '';
  (window.__nativeFetch || fetch)('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var items = cart.items || [];
      var payload = { quantity: newQty };
      var exact = items.filter(function(it) { return it.key === key; });
      if (exact.length === 1) {
        payload.id = key;                                 /* rendered key still valid */
      } else if (variantId) {
        var matches = [];
        for (var i = 0; i < items.length; i++) {
          if (String(items[i].variant_id) === String(variantId)) matches.push({ key: items[i].key, line: i + 1 });
        }
        if (matches.length === 1) { payload.id = matches[0].key; }        /* fresh key */
        else if (!isNaN(index) && index > 0 && index <= items.length) { payload.line = index; }
        else if (matches.length > 1) { payload.line = index; }            /* ambiguous -> position */
      } else if (!isNaN(index) && index > 0) {
        payload.line = index;
      }
      if (!payload.id && !payload.line) {
        tcQtyFail('Couldn’t update quantity — try refreshing');
        return;
      }
      return (window.__nativeFetch || fetch)('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.status) { tcQtyFail(data.description); return; }
        tcRefresh();
      });
    })
    .catch(function() { tcQtyFail('Something didn’t work — try again'); });
}

/* ── Remove with undo (optimistic) ─────────────────────────────── */
var _tcUndoTimers = {};
function tcRemove(btn) {
  var key = btn.dataset.key;
  var item = btn.closest('.tc-item');
  if (!item) return;

  /* Capture item info for undo (need variant ID + qty to re-add) */
  var titleEl = item.querySelector('.tc-item__title');
  var title = titleEl ? titleEl.textContent.trim() : 'Item';
  var qtyEl = item.querySelector('.tc-qty__val');
  var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
  var variantId = key.split(':')[0];

  /* Show spinner on item immediately */
  item.classList.add('tc-item--loading');

  /* Fire removal immediately */
  (window.__nativeFetch || fetch)('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (data.status) {
      item.classList.remove('tc-item--loading');
      tcToast(data.description || 'Couldn\u2019t remove item \u2014 try again');
      return;
    }
    /* Swap to undo bar after successful removal */
    var undoEl = document.createElement('div');
    undoEl.className = 'tc-item--undo';
    undoEl.id = 'TcUndo-' + key.replace(/:/g, '-');
    undoEl.innerHTML =
      '<span>' + title.substring(0, 20) + (title.length > 20 ? '...' : '') + ' removed</span>' +
      '<button type="button" onclick="tcUndoRemove(\'' + variantId + '\',' + qty + ',\'' + key + '\')">Undo</button>';
    if (item.parentNode) {
      item.parentNode.replaceChild(undoEl, item);
    }
    /* Immediately update shipping bar, header count, and total from cart data */
    tcLiveUpdate(data);
    /* Auto-refresh after undo window */
    _tcUndoTimers[key] = setTimeout(function() {
      delete _tcUndoTimers[key];
      tcRefresh();
    }, 3500);
  })
  .catch(function() {
    item.classList.remove('tc-item--loading');
    tcToast('Couldn\u2019t remove item \u2014 try again');
  });
}

function tcUndoRemove(variantId, qty, key) {
  /* Cancel the pending refresh */
  if (_tcUndoTimers[key]) {
    clearTimeout(_tcUndoTimers[key]);
    delete _tcUndoTimers[key];
  }
  /* Re-add the item that was already removed */
  var undoEl = document.getElementById('TcUndo-' + key.replace(/:/g, '-'));
  if (undoEl) {
    var undoBtn = undoEl.querySelector('button');
    if (undoBtn) { undoBtn.textContent = '...'; undoBtn.disabled = true; }
  }
  (window.__nativeFetch || fetch)('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (data.status) {
      tcToast(data.description || 'Couldn\u2019t restore that item');
    }
    tcRefresh();
  })
  .catch(function() {
    tcToast('Couldn\u2019t restore that item \u2014 try again');
    tcRefresh();
  });
}

/* ── Tier savings ladder (spend more, save more) ────────────────────
   Fills each segment by the cart's product subtotal (add-ons excluded) and
   flips the free-shipping status line. Static tier labels, no "spend $X
   more" copy. Reads thresholds/percentages from data-attrs. ── */
function tcUpdateTierBar() {
  var wrap = document.querySelector('.tc-tiers');
  if (!wrap) return;
  (window.__nativeFetch || fetch)('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var redoId = String(typeof _tcRedoVariantId !== 'undefined' ? _tcRedoVariantId : '');
      var rushId = String(typeof _tcRushVariantId !== 'undefined' ? _tcRushVariantId : '');
      var sub = 0;
      (cart.items || []).forEach(function(it) {
        var v = String(it.variant_id);
        if (v === redoId || v === rushId) return;           /* add-ons don't count toward spend */
        sub += (it.final_line_price || it.line_price || 0);
      });
      var tiers = [
        { thr: parseInt(wrap.dataset.t1, 10) || 0, pct: parseInt(wrap.dataset.p1, 10) || 0 },
        { thr: parseInt(wrap.dataset.t2, 10) || 0, pct: parseInt(wrap.dataset.p2, 10) || 0 },
        { thr: parseInt(wrap.dataset.t3, 10) || 0, pct: parseInt(wrap.dataset.p3, 10) || 0 }
      ];
      var segs = wrap.querySelectorAll('.tc-tier');
      var prev = 0, next = null;
      for (var i = 0; i < tiers.length; i++) {
        var t = tiers[i], el = segs[i];
        if (!el) continue;
        var span = t.thr - prev;
        var frac = span > 0 ? (sub - prev) / span : 0;
        frac = Math.max(0, Math.min(1, frac));
        var fill = el.querySelector('.tc-tier__fill');
        if (fill) fill.style.width = (frac * 100) + '%';
        var unlocked = sub >= t.thr;
        el.classList.toggle('is-unlocked', unlocked);
        prev = t.thr;
      }

      /* Free-shipping status line — static label, flips to unlocked. No "spend $X more". */
      var ship = document.getElementById('TcTiersShip');
      if (ship) {
        var shipThr = parseInt(wrap.dataset.ship, 10) || 0;
        if (shipThr > 0 && sub >= shipThr) {
          ship.classList.add('is-unlocked');
          ship.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>Free shipping unlocked';
        } else {
          ship.classList.remove('is-unlocked');
          ship.textContent = ship.dataset.shipLabel || 'Free shipping';
        }
      }
    })
    .catch(function() {});
}

/* Any 2 for $99: a pair shows as one item, so Remove takes out both of its lines. Lines are matched by _pair_id on a
   fresh cart (line keys go stale when the discount reallocates, see tcQty) and zeroed by position with /cart/update.js. */
function tcRemovePair(btn) {
  var pid = btn.getAttribute('data-pair-id');
  var block = btn.closest('.tc-pair');
  if (block) block.classList.add('tc-item--loading');
  btn.disabled = true;
  var f = window.__nativeFetch || fetch;
  f('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var updates = cart.items.map(function (l) { return (l.properties && l.properties._pair_id === pid) ? 0 : l.quantity; });
      return f('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) });
    })
    .then(function (r) { if (!r.ok) throw new Error('update'); return r.json(); })
    .then(function (cart) {
      tcRefresh();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tc-pair-remove', cartData: cart });
    })
    .catch(function () {
      if (block) block.classList.remove('tc-item--loading');
      btn.disabled = false;
      tcToast('Couldn\u2019t remove that pair. Try again');
    });
}

/* Drop just the 3rd piece of a set; the first two stay together at the set price */
function tcRemoveThird(btn) {
  var row = btn.closest('.tc-pair__row');
  if (row) row.classList.add('tc-item--loading');
  btn.disabled = true;
  (window.__nativeFetch || fetch)('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: btn.getAttribute('data-key'), quantity: 0 })
  })
    .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
    .then(function (cart) {
      tcRefresh();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tc-third-remove', cartData: cart });
    })
    .catch(function () {
      if (row) row.classList.remove('tc-item--loading');
      btn.disabled = false;
      tcToast('Couldn\u2019t remove that piece. Try again');
    });
}

function tcRefresh() {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  (window.__nativeFetch || fetch)('/cart?sections=cart-drawer,cart-icon-bubble')
    .then(function(r) { return r.json(); })
    .then(function(sections) {
      /* renderContents already calls tcAnimateShippingBar via our patch —
         do NOT call it again here or it reads the 0% reset as the target */
      drawer.renderContents({ id: null, sections: sections });
      var hasItems = drawer.querySelector('.tc-item');
      if (hasItems) { drawer.classList.remove('is-empty'); }
      else { drawer.classList.add('is-empty'); }
    })
    .catch(function() {
      tcToast('Couldn\u2019t refresh your cart. Try again');
    });
}

/* COVERAGE CHECKOUT (theme-managed Redo mirror).
   Opt-in at checkout. "Checkout+" adds Redo's real coverage variant then goes to
   checkout; the plain link removes any coverage then goes to checkout. Coverage is
   never kept in the browsing cart (tcCovSweep clears leftovers on load), so the
   button total (computed fresh in Liquid + JS) is always in sync. */
function tcCovVariant() {
  var el = document.getElementById('TcCov');
  return el ? parseInt(el.getAttribute('data-variant'), 10) : 0;
}
function tcCheckoutWithCoverage(btn) {
  if (btn) { btn.classList.add('is-busy'); }
  var vid = tcCovVariant();
  if (!vid) { window.location.href = '/checkout'; return; }
  /* allow THIS add through the Redo-add block, then go straight to checkout */
  window.__tcCovCheckout = true;
  fetch('/cart/add.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
  }).then(function () { window.location.href = '/checkout'; })
    .catch(function () { window.location.href = '/checkout'; });
}
function tcCheckoutWithout(btn) {
  if (btn) { btn.classList.add('is-busy'); }
  var vid = tcCovVariant();
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    var line = (cart.items || []).find(function (i) { return i.variant_id === vid; });
    if (!line) { window.location.href = '/checkout'; return; }
    window.__tcRedoToggleRemove = true;
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 })
    }).then(function () { window.location.href = '/checkout'; });
  }).catch(function () { window.location.href = '/checkout'; });
}
function tcCovInfo(btn) {
  var pop = document.getElementById('TcCovPop');
  if (!pop) return;
  var opening = pop.hasAttribute('hidden');
  if (opening) { pop.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); }
  else { pop.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); return; }
  setTimeout(function () {
    function close(e) {
      if (!pop.contains(e.target) && e.target !== btn) {
        pop.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', close);
      }
    }
    document.addEventListener('click', close);
  }, 10);
}
/* On load, clear ALL leftover coverage lines from the browsing cart (back button from
   checkout, or coverage Redo auto-added before our add-block installed) so the cart shows
   products only and totals stay honest. Removes every matching line, not just the first. */
function tcCovSweep() {
  if (window.__tcCovCheckout) return; /* mid Checkout+ — don't strip the coverage we just added */
  var vid = tcCovVariant();
  if (!vid) return;
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    var keys = (cart.items || []).filter(function (i) { return i.variant_id === vid; }).map(function (i) { return i.key; });
    if (!keys.length) return;
    return keys.reduce(function (p, key) {
      return p.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
      });
    }, Promise.resolve()).then(function () { tcRefresh(); });
  }).catch(function () {});
}

/* ── Animate shipping bar ──────────────────────────────────────── */
function tcAnimateShippingBar(drawer) {
  var fill = drawer.querySelector('.tc-shipping__fill');
  if (!fill) return;
  var target = fill.style.width;
  fill.style.transition = 'none';
  fill.style.width = '0%';
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      fill.style.transition = '';
      fill.style.width = target;
    });
  });
}

/* ── Reservation countdown (5-min, sessionStorage-persisted, old-cart pattern) ── */
var _tcReserveTimer = null;
function tcReserveInit() {
  var el = document.getElementById('TcReserveTime');
  var bar = document.getElementById('TcReserve');
  if (!el || !bar) return;
  if (_tcReserveTimer) { clearInterval(_tcReserveTimer); _tcReserveTimer = null; }
  var KEY = 'tc_reserve_start', DUR = 5 * 60 * 1000;
  var start = parseInt(sessionStorage.getItem(KEY) || '0', 10);
  if (!start) { start = Date.now(); try { sessionStorage.setItem(KEY, String(start)); } catch (e) {} }
  function tick() {
    var left = DUR - (Date.now() - start);
    if (left <= 0) {
      bar.style.display = 'none';
      if (_tcReserveTimer) { clearInterval(_tcReserveTimer); _tcReserveTimer = null; }
      return;
    }
    bar.style.display = '';
    var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
    el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }
  tick();
  _tcReserveTimer = setInterval(tick, 1000);
}

/* ── Live-update shipping bar, header, total without full re-render ── */
function tcLiveUpdate(cartData) {
  /* cartData = response from /cart/change.js (has items, total_price, item_count) */
  /* Exclude Redo + Rush line items from totals and counts for display purposes */
  var redoTotal = 0, redoCount = 0, redoInCart = false;
  var rushTotal = 0, rushCount = 0, rushInCart = false;
  if (cartData.items) {
    cartData.items.forEach(function(item) {
      if (item.variant_id === _tcRedoVariantId) {
        redoTotal = item.final_line_price || item.line_price || 0;
        redoCount = item.quantity || 0;
        redoInCart = true;
      } else if (item.variant_id === _tcRushVariantId) {
        rushTotal = item.final_line_price || item.line_price || 0;
        rushCount = item.quantity || 0;
        rushInCart = true;
      }
    });
  }
  var total = (cartData.total_price || 0) - redoTotal - rushTotal;
  var count = (cartData.item_count || 0) - redoCount - rushCount;

  /* Update header count */
  var titleEl = document.querySelector('.tc-header__title');
  if (titleEl) {
    titleEl.textContent = 'Your Cart' + (count > 0 ? ' (' + count + ')' : '');
  }

  /* Free-shipping callout (above checkout): compare cart total against threshold */
  var fsEl = document.getElementById('TcFreeship');
  if (fsEl) {
    var fsThreshold = parseInt(fsEl.dataset.threshold, 10) || 0;
    var fsTotal = cartData.total_price || 0;
    if (fsThreshold > 0 && fsTotal >= fsThreshold) {
      fsEl.classList.add('is-unlocked');
      fsEl.innerHTML = 'Your order qualifies for free shipping \ud83d\udd25';
    } else {
      fsEl.classList.remove('is-unlocked');
      var fsRemaining = Math.max(0, fsThreshold - fsTotal);
      fsEl.innerHTML = 'Spend <strong>' + tcFormatMoney(fsRemaining) + '</strong> more to get free shipping';
    }
  }

  /* Update subtotal — pre-discount product subtotal (add-ons excluded), so it
     matches the Liquid cart_total and reads like an order summary (Subtotal before
     the discount line), not the discounted total. */
  var productSubtotal = 0;
  if (cartData.items) {
    cartData.items.forEach(function(it) {
      if (it.variant_id === _tcRedoVariantId || it.variant_id === _tcRushVariantId) return;
      productSubtotal += (it.final_line_price || it.line_price || 0);
    });
  }
  var subEl = document.getElementById('TcSubtotalValue');
  if (subEl) subEl.textContent = tcFormatMoney(productSubtotal);

  /* Update protection line visibility + value (animated) */
  var protLine = document.getElementById('TcProtectLine');
  var protVal = document.getElementById('TcProtectLineValue');
  if (protLine) {
    if (redoInCart) {
      protLine.classList.remove('is-hidden');
    } else {
      protLine.classList.add('is-hidden');
    }
    if (protVal && redoInCart) protVal.textContent = tcFormatMoney(redoTotal);
  }

  /* Update total (full cart total including Redo if present) */
  var totalEl = document.getElementById('TcTotalValue');
  var wrapper = document.getElementById('TcTotal');
  if (totalEl && wrapper) {
    wrapper.dataset.base = total;
    totalEl.textContent = tcFormatMoney(cartData.total_price || 0);
  }

  /* Coverage checkout total = cart total + coverage price (coverage is opt-in
     at checkout, so it isn't kept in the browsing cart — add it for the button). */
  var covTotalEl = document.getElementById('TcCovTotal');
  var covElUpd = document.getElementById('TcCov');
  if (covTotalEl && covElUpd) {
    var covP = parseInt(covElUpd.getAttribute('data-redo-price'), 10) || 0;
    var covV = parseInt(covElUpd.getAttribute('data-variant'), 10) || 0;
    var hasCovNow = (cartData.items || []).some(function (i) { return i.variant_id === covV; });
    var covBase = cartData.total_price || 0;
    covTotalEl.textContent = tcFormatMoney(hasCovNow ? covBase : covBase + covP);
  }

  /* Deal anchor: struck pre-discount total next to the real total */
  var saved = cartData.total_discount || 0;
  var orig = cartData.original_total_price || 0;
  var wasEl = document.getElementById('TcTotalWas');
  if (wasEl) {
    if (saved > 0) { wasEl.textContent = tcFormatMoney(orig); wasEl.hidden = false; }
    else { wasEl.hidden = true; }
  }
  /* "You saved" badge follows the same numbers */
  var savedEl = document.getElementById('TcTotalSaved');
  if (savedEl) {
    if (saved > 0) { savedEl.textContent = 'You saved ' + tcFormatMoney(saved).replace(/\.00$/, ''); savedEl.hidden = false; }
    else { savedEl.hidden = true; }
  }

  /* Shipping value line (Free once the threshold is met) */
  var shipValEl = document.getElementById('TcShipValue');
  if (shipValEl) {
    var tiersEl = document.querySelector('.tc-tiers');
    var shipThr = tiersEl ? (parseInt(tiersEl.dataset.ship, 10) || 0) : 0;
    if (shipThr > 0 && (cartData.total_price || 0) >= shipThr) {
      shipValEl.textContent = 'Free'; shipValEl.classList.add('is-free');
    } else {
      shipValEl.textContent = 'Free over $' + Math.round(shipThr / 100); shipValEl.classList.remove('is-free');
    }
  }

  /* Update rush line visibility + value */
  var rushLine = document.getElementById('TcRushLine');
  var rushVal = document.getElementById('TcRushLineValue');
  if (rushLine) {
    if (rushInCart) { rushLine.classList.remove('is-hidden'); }
    else { rushLine.classList.add('is-hidden'); }
    if (rushVal && rushInCart) rushVal.textContent = tcFormatMoney(rushTotal);
  }

  /* Sync protection + rush state */
  _tcProtectOn = redoInCart;
  _tcRushOn = rushInCart;

  /* Sync rush button UI */
  var rushBtn = document.getElementById('TcRush');
  if (rushBtn) {
    if (rushInCart) rushBtn.classList.add('is-added');
    else rushBtn.classList.remove('is-added');
  }

  /* Toggle empty state if cart is now empty */
  if (count === 0) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.add('is-empty');
  }
}

/* ── Cross-sell variant picker + quick add ─────────────────────── */
var _tcCartFinish = window.__tcDrawer.cartFinish;

function tcXsellPick(btn) {
  var card = btn.closest('.tc-xsell__card');
  var picker = card.querySelector('.tc-xsell__picker');

  /* If product has only 1 variant (no picker), add directly */
  if (!picker) {
    var variants = [];
    try { variants = JSON.parse(card.dataset.xsellVariants || '[]'); } catch(e) {}
    if (variants.length > 0) {
      _tcXsellDoAdd(btn, variants[0].id);
    }
    return;
  }

  /* Toggle picker open/closed */
  var isOpen = picker.classList.contains('is-open');
  /* Close any other open pickers first */
  document.querySelectorAll('.tc-xsell__picker.is-open').forEach(function(p) {
    p.classList.remove('is-open');
    var otherBtn = p.closest('.tc-xsell__card').querySelector('.tc-xsell__add');
    if (otherBtn) { otherBtn.classList.remove('is-picking'); }
  });

  if (isOpen) return; /* was open, now closed */

  picker.classList.add('is-open');
  btn.classList.add('is-picking');
  /* SVG rotates to × via CSS .is-picking */

  /* Auto-select finish matching cart if not already selected */
  if (!picker.querySelector('.tc-xsell__swatch.is-active')) {
    var autoMatch = null;
    if (_tcCartFinish) {
      autoMatch = picker.querySelector('.tc-xsell__swatch[data-finish="' + _tcCartFinish + '"]');
      /* Fuzzy match: steel/silver/polished → silver family, gold/18k → gold family */
      if (!autoMatch) {
        var cf = _tcCartFinish.toLowerCase();
        var family = '';
        if (cf.indexOf('steel') > -1 || cf.indexOf('silver') > -1 || cf.indexOf('polished') > -1) family = 'silver';
        else if (cf.indexOf('gold') > -1) family = 'gold';
        else if (cf.indexOf('black') > -1) family = 'black';
        if (family) {
          picker.querySelectorAll('.tc-xsell__swatch').forEach(function(sw) {
            if (autoMatch) return;
            var f = sw.dataset.finish.toLowerCase();
            if (family === 'silver' && (f.indexOf('steel') > -1 || f.indexOf('silver') > -1 || f.indexOf('polished') > -1)) autoMatch = sw;
            else if (family === 'gold' && f.indexOf('gold') > -1) autoMatch = sw;
            else if (family === 'black' && f.indexOf('black') > -1) autoMatch = sw;
          });
        }
      }
    }
    /* If no cart match, auto-select if only one finish */
    if (!autoMatch) {
      var swatches = picker.querySelectorAll('.tc-xsell__swatch');
      if (swatches.length === 1) autoMatch = swatches[0];
    }
    if (autoMatch) autoMatch.classList.add('is-active');
  }
  /* Always update size availability, image, and label based on active finish */
  var activeSw = picker.querySelector('.tc-xsell__swatch.is-active');
  if (activeSw) {
    _tcXsellUpdateSizes(card);
    _tcXsellUpdateFinishLabel(card, activeSw.dataset.finish);
    _tcXsellUpdateImage(card, activeSw.dataset.finish);
  }

  /* Scroll picker into view after expand animation completes */
  setTimeout(function() {
    var lastRow = picker.querySelector('.tc-xsell__sizes') || picker.querySelector('.tc-xsell__finishes') || picker;
    lastRow.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, 320);
}

function tcXsellFinish(swatch) {
  var card = swatch.closest('.tc-xsell__card');
  /* Deselect siblings, select this */
  card.querySelectorAll('.tc-xsell__swatch').forEach(function(s) { s.classList.remove('is-active'); });
  swatch.classList.add('is-active');
  /* Reset size selection and update availability */
  card.querySelectorAll('.tc-xsell__size').forEach(function(s) {
    s.classList.remove('is-active');
  });
  _tcXsellUpdateSizes(card);
  _tcXsellUpdateFinishLabel(card, swatch.dataset.finish);
  /* Swap product image to match selected finish */
  _tcXsellUpdateImage(card, swatch.dataset.finish);
}

function _tcXsellUpdateFinishLabel(card, finishName) {
  var label = card.querySelector('.tc-xsell__finish-name');
  if (label) label.textContent = finishName;
}

function _tcXsellUpdateImage(card, finish) {
  var variants = [];
  try { variants = JSON.parse(card.dataset.xsellVariants || '[]'); } catch(e) {}
  /* Find first variant with this finish that has an image */
  var match = variants.find(function(v) { return v.o1 === finish && v.img; });
  if (match && match.img) {
    var img = card.querySelector('.tc-xsell__img > img');
    if (img) {
      img.style.opacity = '0';
      img.style.transition = 'opacity 0.2s ease';
      setTimeout(function() {
        img.src = match.img;
        img.style.opacity = '1';
      }, 200);
    }
  }
}

function _tcXsellUpdateSizes(card) {
  var finish = '';
  var activeSwatch = card.querySelector('.tc-xsell__swatch.is-active');
  if (activeSwatch) finish = activeSwatch.dataset.finish;
  var variants = [];
  try { variants = JSON.parse(card.dataset.xsellVariants || '[]'); } catch(e) {}
  /* Get sizes available for this finish */
  var availableSizes = {};
  variants.forEach(function(v) {
    if (v.o1 === finish || !finish) availableSizes[v.o2] = true;
  });
  card.querySelectorAll('.tc-xsell__size').forEach(function(btn) {
    if (availableSizes[btn.dataset.size]) {
      btn.classList.remove('is-unavailable');
    } else {
      btn.classList.add('is-unavailable');
      btn.classList.remove('is-active');
    }
  });
}

function tcXsellSize(sizeBtn) {
  var card = sizeBtn.closest('.tc-xsell__card');
  /* Deselect siblings, select this */
  card.querySelectorAll('.tc-xsell__size').forEach(function(s) { s.classList.remove('is-active'); });
  sizeBtn.classList.add('is-active');

  /* Both selected? Find matching variant and add */
  var finish = '';
  var activeSwatch = card.querySelector('.tc-xsell__swatch.is-active');
  if (activeSwatch) finish = activeSwatch.dataset.finish;
  var size = sizeBtn.dataset.size;
  var hasFinishOption = card.querySelectorAll('.tc-xsell__swatch').length > 0;

  var variants = [];
  try { variants = JSON.parse(card.dataset.xsellVariants || '[]'); } catch(e) {}

  var match;
  if (hasFinishOption && finish) {
    /* Strict match: must match both finish and size */
    match = variants.find(function(v) { return v.o1 === finish && v.o2 === size; });
  } else {
    /* Single-option product: match by size only */
    match = variants.find(function(v) { return v.o2 === size || v.o1 === size; });
  }

  if (match) {
    var addBtn = card.querySelector('.tc-xsell__add');
    _tcXsellDoAdd(addBtn, match.id);
  } else if (hasFinishOption && finish) {
    tcToast('Not available in ' + finish + ' / ' + size);
    sizeBtn.classList.remove('is-active');
  }
}

function _tcXsellDoAdd(btn, variantId) {
  btn.classList.remove('is-picking');
  btn.classList.add('is-adding');
  btn.textContent = '';

  (window.__nativeFetch || fetch)('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (data.status) {
      btn.classList.remove('is-adding', 'is-picking');
      tcToast(data.description || 'Couldn\u2019t add to cart. Try again');
      return;
    }
    btn.classList.remove('is-adding', 'is-picking');
    btn.classList.add('is-done');
    /* Close picker */
    var picker = btn.closest('.tc-xsell__card').querySelector('.tc-xsell__picker');
    if (picker) picker.classList.remove('is-open');
    setTimeout(function() { tcRefresh(); }, 600);
  })
  .catch(function() {
    btn.classList.remove('is-adding', 'is-picking');
    tcToast('Couldn\u2019t add to cart. Try again');
  });
}

/* ── Protection toggle — adds/removes real Redo variant ────────── */
var _tcProtectOn = window.__tcDrawer.redoInCart; /* initial state from Liquid */
var _tcProtectBusy = false;
var _tcRedoVariantId = window.__tcDrawer.redoVariantId;

/* ── Rush processing toggle ──────────────────────────────────────── */
var _tcRushOn = window.__tcDrawer.rushInCart;
var _tcRushBusy = false;
var _tcRushVariantId = window.__tcDrawer.rushVariantId;

/* ── Protection info popover ── */
function tcToggleProtectInfo(infoBtn) {
  var popover = document.getElementById('TcProtectPopover');
  if (!popover) return;
  var isOpen = popover.classList.contains('is-open');
  if (isOpen) {
    popover.classList.remove('is-open');
  } else {
    /* Position arrow under the (i) button */
    var protect = infoBtn.closest('.tc-protect');
    if (protect) {
      var btnCenter = infoBtn.offsetLeft + infoBtn.offsetWidth / 2;
      var popoverLeft = 20; /* matches CSS left: 20px */
      popover.style.setProperty('--arrow-left', (btnCenter - popoverLeft) + 'px');
    }
    popover.classList.add('is-open');
    /* Close on outside click */
    setTimeout(function() {
      function closeHandler(e) {
        if (!popover.contains(e.target) && e.target !== infoBtn) {
          popover.classList.remove('is-open');
          document.removeEventListener('click', closeHandler);
        }
      }
      document.addEventListener('click', closeHandler);
    }, 10);
  }
}

function tcToggleProtect(toggleBtn) {
  if (_tcProtectBusy) return;
  _tcProtectBusy = true;
  var newState = !_tcProtectOn;
  toggleBtn.setAttribute('aria-checked', newState ? 'true' : 'false');
  toggleBtn.classList.add('is-loading');

  /* If user explicitly turns OFF, prevent auto-add from overriding */
  if (!newState) _tcAutoAddDone = true;

  /* Show/hide nudge */
  var nudge = document.getElementById('TcProtectNudge');
  if (nudge) {
    if (newState) {
      nudge.classList.remove('is-visible');
    } else {
      nudge.classList.add('is-visible');
    }
  }

  if (newState) {
    /* Add Redo variant to cart */
    (window.__nativeFetch || fetch)('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: _tcRedoVariantId, quantity: 1 }] })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) {
        /* Redo add failed — revert toggle */
        toggleBtn.setAttribute('aria-checked', 'false');
        tcToast(data.description || 'Couldn\u2019t add protection \u2014 try again');
        return;
      }
      _tcProtectOn = true;
      tcRefresh();
    })
    .catch(function() {
      toggleBtn.setAttribute('aria-checked', 'false');
      tcToast('Couldn\u2019t add protection \u2014 try again');
    })
    .finally(function() {
      _tcProtectBusy = false;
      toggleBtn.classList.remove('is-loading');
      tcSyncSubtotalVisibility();
    });
  } else {
    /* Remove Redo variant from cart — find its line key */
    window.__tcRedoToggleRemove = true;
    (window.__nativeFetch || fetch)('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var redoItem = cart.items.find(function(i) { return i.variant_id === _tcRedoVariantId; });
      if (!redoItem) {
        _tcProtectOn = false;
        tcRefresh();
        return;
      }
      return (window.__nativeFetch || fetch)('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: redoItem.key, quantity: 0 })
      }).then(function(r) { return r.json(); });
    })
    .then(function(data) {
      if (data && data.status) {
        toggleBtn.setAttribute('aria-checked', 'true');
        tcToast(data.description || 'Couldn\u2019t remove protection \u2014 try again');
        return;
      }
      _tcProtectOn = false;
      tcRefresh();
    })
    .catch(function() {
      toggleBtn.setAttribute('aria-checked', 'true');
      tcToast('Couldn\u2019t remove protection \u2014 try again');
    })
    .finally(function() {
      _tcProtectBusy = false;
      window.__tcRedoToggleRemove = false;
      toggleBtn.classList.remove('is-loading');
      tcSyncSubtotalVisibility();
    });
  }
}

function tcUpdateProtectTotal() {
  /* Client-side total display until tcRefresh re-fetches authoritative totals. */
  var totalEl = document.getElementById('TcTotalValue');
  var wrapper = document.getElementById('TcTotal');
  if (!totalEl || !wrapper) return;
  var base = parseInt(wrapper.dataset.base, 10) || 0;
  var redo = parseInt(wrapper.dataset.redo, 10) || 0;
  var rush = parseInt(wrapper.dataset.rush, 10) || 0;
  var final = base
    + (_tcProtectOn ? redo : 0)
    + (_tcRushOn ? rush : 0);
  totalEl.textContent = tcFormatMoney(final);
}

/* Sync toggle state after re-render (innerHTML replaced the toggle) */
function tcSyncProtectState() {
  var toggle = document.getElementById('TcProtectToggle');
  if (toggle) {
    _tcProtectOn = toggle.getAttribute('aria-checked') === 'true';
  }
  var rushToggle = document.getElementById('TcRushToggle');
  if (rushToggle) {
    _tcRushOn = rushToggle.getAttribute('aria-checked') === 'true';
  }
  tcUpdateProtectTotal();
  tcSyncSubtotalVisibility();
}

/* ── Rush processing toggle — adds/removes rush variant ──────────── */
function tcToggleRush(wrapper) {
  if (_tcRushBusy) return;
  _tcRushBusy = true;
  var toggleBtn = document.getElementById('TcRushToggle');
  var newState = !_tcRushOn;
  if (toggleBtn) {
    toggleBtn.setAttribute('aria-checked', newState ? 'true' : 'false');
    toggleBtn.classList.add('is-loading');
  }

  if (newState) {
    (window.__nativeFetch || fetch)('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: _tcRushVariantId, quantity: 1 }] })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) {
        if (toggleBtn) toggleBtn.setAttribute('aria-checked', 'false');
        tcToast(data.description || 'Couldn\u2019t add rush processing \u2014 try again');
        return;
      }
      _tcRushOn = true;
      tcUpdateProtectTotal();
      tcRefresh();
    })
    .catch(function() {
      if (toggleBtn) toggleBtn.setAttribute('aria-checked', 'false');
      tcToast('Couldn\u2019t add rush processing \u2014 try again');
    })
    .finally(function() {
      _tcRushBusy = false;
      if (toggleBtn) toggleBtn.classList.remove('is-loading');
      tcSyncSubtotalVisibility();
    });
  } else {
    /* Remove rush variant from cart */
    (window.__nativeFetch || fetch)('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var rushItem = cart.items.find(function(i) { return i.variant_id === _tcRushVariantId; });
      if (!rushItem) {
        _tcRushOn = false;
        tcRefresh();
        return;
      }
      return (window.__nativeFetch || fetch)('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: rushItem.key, quantity: 0 })
      }).then(function(r) { return r.json(); });
    })
    .then(function(data) {
      if (data && data.status) {
        if (toggleBtn) toggleBtn.setAttribute('aria-checked', 'true');
        tcToast(data.description || 'Couldn\u2019t remove rush processing \u2014 try again');
        return;
      }
      _tcRushOn = false;
      tcUpdateProtectTotal();
      tcRefresh();
    })
    .catch(function() {
      if (toggleBtn) toggleBtn.setAttribute('aria-checked', 'true');
      tcToast('Couldn\u2019t remove rush processing \u2014 try again');
    })
    .finally(function() {
      _tcRushBusy = false;
      if (toggleBtn) toggleBtn.classList.remove('is-loading');
      tcSyncSubtotalVisibility();
    });
  }
}

/* ── Subtotal row visibility — show when add-ons active, hide when clean ── */
function tcSyncSubtotalVisibility() {
  var sub = document.getElementById('TcSubtotal');
  if (!sub) return;
  var hasAddons = _tcProtectOn || _tcRushOn;
  if (hasAddons) { sub.classList.remove('is-hidden'); }
  else { sub.classList.add('is-hidden'); }
}

/* ── Auto-add Redo when cart has items but no Redo (default ON) ── */
var _tcAutoAddDone = false;
function tcAutoAddRedo() {
  return; /* disabled: coverage is opt-in at checkout via the tc-cov widget, never auto-added to the browsing cart */
  if (_tcProtectOn || _tcProtectBusy || _tcAutoAddDone) return;
  _tcAutoAddDone = true;
  /* Check if cart has real products but no Redo */
  (window.__nativeFetch || fetch)('/cart.js')
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    var hasRedo = cart.items.some(function(i) { return i.variant_id === _tcRedoVariantId; });
    var hasProducts = cart.items.some(function(i) { return i.variant_id !== _tcRedoVariantId; });
    if (hasProducts && !hasRedo) {
      return (window.__nativeFetch || fetch)('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: _tcRedoVariantId, quantity: 1 }] })
      }).then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.status) {
          _tcProtectOn = true;
          tcRefresh();
        }
      });
    }
  })
  .catch(function() { /* silent fail — user can still toggle manually */ });
}

/* Simple money formatter — matches Shopify $ format */
function tcFormatMoney(cents) {
  var d = (cents / 100).toFixed(2);
  return '$' + d.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/* ── Discount code ─────────────────────────────────────────────── */
function tcToggleDiscount(btn) {
  var form = document.getElementById('TcDiscountForm');
  if (!form) return;
  var isOpen = form.classList.contains('is-open');
  form.classList.toggle('is-open');
  btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  if (!isOpen) {
    setTimeout(function() {
      var input = document.getElementById('TcDiscountInput');
      if (input) input.focus();
    }, 100);
  }
}

function tcApplyDiscount() {
  var input = document.getElementById('TcDiscountInput');
  var applyBtn = document.getElementById('TcDiscountApply');
  var msgEl = document.getElementById('TcDiscountMsg');
  if (!input) return;
  var code = input.value.trim();
  if (!code) {
    input.focus();
    return;
  }
  applyBtn.disabled = true;
  applyBtn.textContent = '...';

  /* Shopify: apply discount via /discount/CODE then refresh cart */
  (window.__nativeFetch || fetch)('/discount/' + encodeURIComponent(code), {
    method: 'GET',
    redirect: 'follow'
  })
  .then(function() {
    /* After the redirect completes, refresh the cart to pick up new prices */
    return (window.__nativeFetch || fetch)('/cart.js');
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    applyBtn.disabled = false;
    applyBtn.textContent = 'Apply';
    /* Show applied pill before clearing input */
    var appliedCode = code.toUpperCase();
    input.value = '';
    /* Hide the form, show pill on the toggle button */
    var form = document.getElementById('TcDiscountForm');
    if (form) form.classList.remove('is-open');
    var toggleBtn = document.querySelector('.tc-discount-toggle');
    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', 'false');
      /* Insert pill after toggle if not already there */
      var existingPill = document.getElementById('TcDiscountPill');
      if (existingPill) existingPill.remove();
      var pill = document.createElement('span');
      pill.id = 'TcDiscountPill';
      pill.className = 'tc-discount-applied';
      pill.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>' + appliedCode;
      toggleBtn.parentNode.insertBefore(pill, toggleBtn.nextSibling);
    }
    /* Refresh picks up new prices — discount row + updated totals render server-side */
    tcRefresh();
  })
  .catch(function() {
    applyBtn.disabled = false;
    applyBtn.textContent = 'Apply';
    tcToast('That code didn\u2019t work \u2014 check and try again');
  });
}

function tcShowDiscountMsg(msg, isError) {
  var el = document.getElementById('TcDiscountMsg');
  if (!el) return;
  el.textContent = msg;
  el.className = 'tc-discount-msg ' + (isError ? 'tc-discount-msg--err' : 'tc-discount-msg--ok');
  el.style.display = '';
  setTimeout(function() { el.style.display = 'none'; }, 6000);
}

/* Allow Enter key to submit discount code */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Enter' && e.target && e.target.id === 'TcDiscountInput') {
    e.preventDefault();
    tcApplyDiscount();
  }
});

/* ── Ring attach row (snippets/cart-ring-attach.liquid) ─────────────────
   Inline onclick/onchange like the rest of the drawer, so the row keeps working
   after every Section Rendering re-render. Same cart contract as the PDP attach
   toggle: _bundle_price (cents) + _bundle_anchor (product GID); the bundle
   discount function prices the line at checkout. */
function _tcAttachRoot(el) { return el.closest('[data-tc-attach]'); }
function _tcAttachVariant(root) {
  var list; try { list = JSON.parse(root.getAttribute('data-variants') || '[]'); } catch (e) { return null; }
  var fsel = root.querySelector('[data-tc-attach-finish]'), ssel = root.querySelector('[data-tc-attach-size]');
  var fl = fsel ? fsel.value : '', sz = ssel ? ssel.value : '';
  var pool = list.filter(function (v) { return (!fl || v.fl === fl) && (!sz || v.s === sz); });
  var live = pool.filter(function (v) { return v.a; });
  return live[0] || pool[0] || null;
}
function tcAttachPick(el) {
  var root = _tcAttachRoot(el); if (!root) return;
  var v = _tcAttachVariant(root);
  var img = root.querySelector('[data-tc-attach-img]'); if (img && v && v.img && img.getAttribute('src') !== v.img) img.src = v.img;
  var btn = root.querySelector('[data-tc-attach-add]');
  if (btn) { var ok = !!(v && v.a); btn.disabled = !ok; btn.textContent = ok ? 'Add' : 'Sold out'; }
}
function tcAttachAdd(btn) {
  var root = _tcAttachRoot(btn); if (!root) return;
  var v = _tcAttachVariant(root); if (!v || !v.a) return;
  var cents = parseInt(root.getAttribute('data-cents'), 10) || 0;
  var anchor = root.getAttribute('data-anchor') || '';
  if (!cents || !anchor) return;
  btn.classList.add('is-adding');
  (window.__nativeFetch || fetch)('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: { _bundle_price: cents, _bundle_anchor: 'gid://shopify/Product/' + anchor } }] })
  })
  .then(function (r) { return r.json(); })
  .then(function (data) {
    if (data && data.status) { btn.classList.remove('is-adding'); tcToast(data.description || 'Couldn\u2019t add to cart. Try again'); return; }
    tcRefresh();
  })
  .catch(function () { btn.classList.remove('is-adding'); tcToast('Couldn\u2019t add to cart. Try again'); });
}
/* ── Vault pendant row (snippets/cart-vault-pendant.liquid) ─────────────
   Full price, so no bundle properties: only _vault_upsell, for counting take rate. */
function tcVaultAdd(btn) {
  var root = btn.closest('[data-tc-vault]'); if (!root) return;
  var id = parseInt(root.getAttribute('data-variant'), 10);
  var anchor = root.getAttribute('data-anchor') || '';
  if (!id || !anchor) return;
  btn.classList.add('is-adding');
  (window.__nativeFetch || fetch)('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _vault_upsell: 'gid://shopify/Product/' + anchor } }] })
  })
  .then(function (r) { return r.json(); })
  .then(function (data) {
    if (data && data.status) { btn.classList.remove('is-adding'); tcToast(data.description || 'Couldn’t add to cart. Try again'); return; }
    tcRefresh();
  })
  .catch(function () { btn.classList.remove('is-adding'); tcToast('Couldn’t add to cart. Try again'); });
}
/* A Vault pendant is only sold alongside its necklace, so when the necklace is removed the
   pendant goes with it. The drawer Liquid lists orphaned line keys in data-vault-orphans. */
var _tcVaultSweeping = false;
function tcVaultSweep() {
  if (_tcVaultSweeping) return;
  var el = document.querySelector('cart-drawer [data-vault-orphans]');
  var keys = el ? (el.getAttribute('data-vault-orphans') || '').split(',').filter(Boolean) : [];
  if (!keys.length) return;
  _tcVaultSweeping = true;
  var f = window.__nativeFetch || fetch;
  keys.reduce(function (p, key) {
    return p.then(function () {
      return f('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
    });
  }, Promise.resolve())
  .then(function () { _tcVaultSweeping = false; tcRefresh(); })
  .catch(function () { _tcVaultSweeping = false; });
}
window.tcVaultSweep = tcVaultSweep;
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tcVaultSweep); else setTimeout(tcVaultSweep, 0);
function tcAttachInitAll() {
  document.querySelectorAll('[data-tc-attach]').forEach(function (root) {
    var ssel = root.querySelector('[data-tc-attach-size]'), fsel = root.querySelector('[data-tc-attach-finish]');
    /* Size options in numeric order (the store lists them 9, 10, 11, 8, 7, 6, 12). */
    if (ssel && !ssel.__tcSorted) {
      ssel.__tcSorted = true;
      var want = ssel.value;
      var opts = Array.prototype.slice.call(ssel.options).sort(function (a, b) { return parseFloat(a.value) - parseFloat(b.value); });
      opts.forEach(function (o) { ssel.appendChild(o); });
      ssel.value = want;
    }
    /* Mirror the anchor's size when that pair is in stock; otherwise the nearest in-stock size for the chosen finish, going up on a tie. */
    var v = _tcAttachVariant(root);
    if (!(v && v.a) && ssel) {
      var list; try { list = JSON.parse(root.getAttribute('data-variants') || '[]'); } catch (e) { list = []; }
      var fl = fsel ? fsel.value : '';
      var target = parseFloat(root.getAttribute('data-size')) || parseFloat(ssel.value) || 0;
      var best = null, bestD = Infinity;
      list.filter(function (x) { return x.a && (!fl || x.fl === fl); }).forEach(function (x) {
        var d = Math.abs(parseFloat(x.s) - target); if (isNaN(d)) d = 999;
        if (d < bestD || (d === bestD && parseFloat(x.s) > parseFloat(best.s))) { best = x; bestD = d; }
      });
      if (best) ssel.value = best.s;
    }
    tcAttachPick(root);
  });
}
window.tcAttachInitAll = tcAttachInitAll;
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tcAttachInitAll); else setTimeout(tcAttachInitAll, 0);


/* Oct 7: COMING SOON GUARD. A product with custom.coming_soon can't be bought, but the theme can't stop every
   path into the cart (old tabs, direct /cart/add links). Any such line in the drawer is removed on sight,
   with a toast saying why. Runs on load and after every drawer re-render. */
var _tcCsBusy = false;
function tcPurgeComingSoon() {
  if (_tcCsBusy) return;
  var rows = document.querySelectorAll('cart-drawer .tc-item[data-coming-soon]');
  if (!rows.length) return;
  _tcCsBusy = true;
  var updates = {}, names = [];
  Array.prototype.forEach.call(rows, function (r) {
    updates[r.getAttribute('data-key')] = 0;
    var n = r.getAttribute('data-coming-soon'); if (names.indexOf(n) === -1) names.push(n);
  });
  (window.__nativeFetch || fetch)('/cart/update.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ updates: updates })
  }).then(function () {
    tcRefresh();
    tcToast(names.join(' and ') + (names.length > 1 ? " aren't" : " isn't") + ' live yet, so we took it out of your cart.');
  }).catch(function () {}).then(function () { setTimeout(function () { _tcCsBusy = false; }, 1500); });
}
window.tcPurgeComingSoon = tcPurgeComingSoon;
(function () {
  var start = function () {
    tcPurgeComingSoon();
    var d = document.querySelector('cart-drawer');
    if (d && window.MutationObserver) new MutationObserver(function () { clearTimeout(tcPurgeComingSoon._t); tcPurgeComingSoon._t = setTimeout(tcPurgeComingSoon, 120); }).observe(d, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else setTimeout(start, 0);
})();
